import React from "react";
import { Button, Input } from "semantic-ui-react";
import { WidgetProps } from "../types";
import Prompt from "../Prompt";
import Summary, { SummaryField, SummaryText, Actions } from "../Summary";

/**
 * "Design principles to apply to life" — five actions with deadlines, and the
 * last challenge in the course: passing it issues the life map PDF.
 */
interface Step {
  action: string;
  deadline: string;
}

const ActionablePlan: React.FC<WidgetProps> = ({
  payload,
  update,
  submit,
  submitting,
  finished,
  question,
  currentUser,
}) => {
  const steps: Step[] = payload.steps || [];

  const editStep = (index: number, changes: Partial<Step>) =>
    update({
      ...payload,
      steps: steps.map((s, i) => (i === index ? { ...s, ...changes } : s)),
    });

  const filled = steps.filter((s) => (s.action || "").trim());
  const complete = filled.length > 0;

  if (finished) {
    return (
      <Summary question={question} currentUser={currentUser}>
        {filled.map((step, i) => (
          <SummaryField key={i} label={step.deadline ? `By ${step.deadline}` : undefined}>
            <SummaryText>{step.action}</SummaryText>
          </SummaryField>
        ))}
      </Summary>
    );
  }

  return (
    <div className="ui form assignment-form">
      <Prompt question={question} currentUser={currentUser} />

      {steps.map((step, i) => (
        <div key={i} className="ix-section ix-step">
          <Input
            fluid
            placeholder="I will…"
            value={step.action || ""}
            onChange={(e) => editStep(i, { action: e.target.value })}
          />
          <Input
            placeholder="By when?"
            value={step.deadline || ""}
            onChange={(e) => editStep(i, { deadline: e.target.value })}
          />
        </div>
      ))}

      <Actions>
        <Button
          primary
          circular
          className="challenge-submit"
          disabled={!complete || submitting}
          loading={submitting}
          onClick={submit}
        >
          Finish
        </Button>
      </Actions>
    </div>
  );
};

export default ActionablePlan;
